<template>
    <div class="ship-card"  @click="openModalDetail(ship)" >
        <div class="header-container" >
            <h3 class="ship-title">
                {{ ship.nom_navire }}
            </h3>
            <span class="ship-total" >

            </span>
        </div>

        <p class="bls-count">
            Date : {{ ship.date_arriver_formatted }}

        </p>
        <p class="bls-count">
            Total BL : ({{ ship.total_num_bl }} au total)
        </p>

        <!--<ul class="bls-list">
            <li @click="openModalDetail(ship, blItem.num_bl)" v-for="(blItem, index) in blList" :key="index" class="bls-item cursor-hand" :style="{ borderLeftColor: 'green' }" >
                <span class="bl-number">{{ blItem.num_bl }}</span>
                <span class="bl-total">{{ (blItem.client) }}</span>
            </li>
        </ul>-->
    </div>
</template>

<script>
export default {
    name: 'ShipCard',
    props: {
        ship: {
            type: Object,
            required: true,
            default: () => ({ name: '', bls: [], color: 'grey' })
        }
    },
    methods: {
        // Méthode utilitaire pour formater un nombre en devise
        formatTotal(total) {
            if (typeof total !== 'number') return 'N/A';
            return total.toLocaleString('fr-FR');
        },
        openModalDetail(ship) {
            this.$emit('open-modal-detail', { ship });
        }
    },
    computed: {
        // Propriété calculée pour obtenir le grand total de tous les BLs
        calculateOverallTotal() {
            return this.ship.bls.reduce((sum, blItem) => sum + blItem.total, 0);
        },
        blList() {
            if (!this.ship.num_bl || !this.ship.nom_client) return [];

            const blArray = this.ship.num_bl.split(';');
            const clientArray = this.ship.nom_client.split(';');

            // Associer chaque BL à son client correspondant
            return blArray.map((bl, index) => ({
                num_bl: bl.trim(),
                client: clientArray[index] ? clientArray[index].trim() : 'N/A'
            }));
        }
    }
}
</script>

<style scoped>
/* 💳 Styles pour la carte individuelle */
.ship-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    width: 100%;
    max-width: 420px;
    flex-grow: 1;
    transition: transform 0.2s;
}

.ship-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.12);
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 2px solid #eee;
    padding-left: 10px;
    margin-bottom: 10px;
}

.ship-title {
    font-size: 1.3em;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
}

.ship-total {
    font-size: 1.1em;
    font-weight: bold;
}

.bls-count {
    font-weight: 600;
    color: #555;
    margin: 10px 0;
    font-style: italic;
}

.bls-list {
    list-style-type: none;
    padding: 0;
    max-height: 180px !important;
    overflow: auto;
}

.bls-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f7f7f7;
    padding: 8px 12px;
    margin: 8px 0;
    border-radius: 4px;
    border-left: 4px solid;
    font-size: 0.95em;
    transition: background-color 0.1s;
}

.bls-item:hover {
    background-color: #f0f0f0;
}

.bl-number {
    font-weight: 500;
    color: #34495e;
}

.bl-total {
    font-weight: bold;
    color: #2980b9;
}
.cursor-hand {
    cursor: pointer;
}
</style>